import { useState } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import {  __experimentalToggleGroupControl as ToggleGroupControl,
       __experimentalToggleGroupControlOption as ToggleGroupControlOption,
      } from '@wordpress/components';

import { CiCalendarDate } from "react-icons/ci";
import { useEffect } from 'react';

export const VariationPicker = ({ IconLayout='', inTimeLineLayout}) => {
    const [imageselectedAnimation, imagesetSelectedAnimation] = useState(IconLayout || 'none');

    const [currentValue, setcurrentValue] = useState('left');

    const handleimageAnimationClick = (animation) => {
        imagesetSelectedAnimation(animation);
        inTimeLineLayout(animation); // Update the parent component with the new animation value
    };

    const imageanimationoptions = [
        { label: __('Layout-1', 'vayu-blocks'), value: 'layout-1' },
        { label: __('Layout-2', 'vayu-blocks'), value: 'layout-2' },
        { label: __('Layout-3', 'vayu-blocks'), value: 'layout-3' },
        { label: __('Layout-4', 'vayu-blocks'), value: 'layout-4' },
        { label: __('Layout-5', 'vayu-blocks'), value: 'layout-5' },
        { label: __('Layout-6', 'vayu-blocks'), value: 'layout-6' },
        { label: __('Layout-7', 'vayu-blocks'), value: 'layout-7' },
        { label: __('Layout-8', 'vayu-blocks'), value: 'layout-8' },
        { label: __('Layout-9', 'vayu-blocks'), value: 'layout-9' },
        { label: __('Layout-10', 'vayu-blocks'), value: 'layout-10'},
        { label: __('Layout-11', 'vayu-blocks'), value: 'layout-11'},
        { label: __('Layout-12', 'vayu-blocks'), value: 'layout-12'},
    ];
    
    // Find the label based on imageselectedAnimation
    const imageselectedOption = imageanimationoptions.find(option => option.value === imageselectedAnimation);
    
    if (imageselectedOption) {
        imagename = imageselectedOption.label;
    }

    const layoutMapping = {
        group1: { left: 'layout-1', right: 'layout-2', top: 'layout-7', bottom: 'layout-8' },
        group2: { left: 'layout-4', right: 'layout-3', top: 'layout-7', bottom:'layout-8'},
        group3: { left: 'layout-6', right: 'layout-5', top: 'layout-11', bottom: 'layout-12' },
    };

    const decide_layout = (currentValue) => {
        // Determine which group the current animation belongs to
        const group = (() => {
            if (['layout-1', 'layout-2', 'layout-7', 'layout-8'].includes(imageselectedAnimation)) return 'group1';
            if (['layout-4', 'layout-3', 'layout-7', 'layout-8'].includes(imageselectedAnimation)) return 'group2';
            if (['layout-6', 'layout-5', 'layout-11', 'layout-12'].includes(imageselectedAnimation)) return 'group3';
            return null; // Default or fallback case
        })();
    
        // Execute the layout update if the group is found
        if (group && layoutMapping[group][currentValue]) {
            handleimageAnimationClick(layoutMapping[group][currentValue]);
        }
    };
    
    const vayu_blocks_set_currnet_value =(value) => {
        setcurrentValue(value);
        decide_layout(value);
    }

    const getPositionFromLayout = (layout) => {
        for (const group of Object.values(layoutMapping)) {
            for (const [position, mappedLayout] of Object.entries(group)) {
                if (mappedLayout === layout) {
                    return position; // 'left', 'right', etc.
                }
            }
        }
        return null;
    };
    
    useEffect(() => {
        if (IconLayout) {
            const position = getPositionFromLayout(IconLayout);
            if (position) {
                setcurrentValue(position); // 'left', 'right', etc.
            }
        }
    }, []);
    
    return (
        <div className="vayu_blocks_animation_panel vayu-blocks-icon-animation-ciompoenet-panel vayu_blcoks_timeline_panel_display vb-timeline-szie">
                
            <div className='vayu_blocks_timeline-layout_animation'>
                <h6 style={{margin:'10px'}}>{__('Timeline Layout')}</h6>
                
            <div className='vb-timeline-wise-fixer'>
                <ToggleGroupControl
                    value={currentValue}
                    onChange={(newValue) => vayu_blocks_set_currnet_value(newValue)}
                    isBlock
                    __nextHasNoMarginBottom={true}
                    __next40pxDefaultSize={true}
                >
                    <ToggleGroupControlOption value="left" label={__('Left','vayu-blocks')} />
                    <ToggleGroupControlOption value="right" label={__('Right','vayu-blocks')} />
                    <ToggleGroupControlOption value="top" label={__('Top', 'vayu-blocks')} />
                    <ToggleGroupControlOption value="bottom" label={__('Bottom', 'vayu-blocks')} />
                </ToggleGroupControl>

                <div className='vayu-blocks-parettimeline-componet-div'>

                    {currentValue==='left' && (
                    <>
                        {/* layout-1 */}
                        <div
                            className={`vayu_blocks-layout-main-div-timeline vayu_blocks-layout-1-main-div-timeline ${imageselectedAnimation === 'layout-1' ? 'selected' : ''}`}
                            onClick={() => handleimageAnimationClick('layout-1')} // Update the animation value when clicked
                            title="Layout-1"
                        >
                        
                        <div className='vayu-blocks-main_parent_div'>
                            <article class="vayu-blocks-timeline__field-componets-new-way">
                                <div class="vayu_blocks-timeline__events-inner-new-components-new_way">
                                </div>
                                <div class="vayu_blocks-timeline__marker-compoents vayu_blocks-timeline__in-view-icon-compoents"></div>
                                <div class="vayu_blocks__date-new-compoents"><CiCalendarDate /></div>
                                {/* <FaCaretRight className='vayu_blcoks_left_icon_icon_timeline'/> */}
                            </article>
                            <article class="vayu-blocks-timeline__field-componets-new-way">
                                <div class="vayu_blocks-timeline__events-inner-new-components-new_way">
                                </div>
                                <div class="vayu_blocks-timeline__marker-compoents vayu_blocks-timeline__in-view-icon-compoents"></div>
                                <div class="vayu_blocks__date-new-compoents"><CiCalendarDate /></div>
                                {/* <FaCaretRight className='vayu_blcoks_left_icon_icon_timeline'/> */}
                            </article>
                            <article class="vayu-blocks-timeline__field-componets-new-way">
                                <div class="vayu_blocks-timeline__events-inner-new-components-new_way">
                                </div>
                                <div class="vayu_blocks-timeline__marker-compoents vayu_blocks-timeline__in-view-icon-compoents"></div>
                                <div class="vayu_blocks__date-new-compoents"><CiCalendarDate /></div>
                                {/* <FaCaretRight className='vayu_blcoks_left_icon_icon_timeline'/> */}
                            </article>

                            <hr className='vayu_blcoks_layout_hr_tag'/>
                        </div>
                            
                        </div>
                    </>
                    )}
                    
                    {currentValue==='right' && (
                        <>
                            {/*layout-2 */}
                            <div
                                className={`vayu_blocks-layout-main-div-timeline vayu_blocks-layout-2-main-div-timeline ${imageselectedAnimation === 'layout-2' ? 'selected' : ''}`}
                                onClick={() => handleimageAnimationClick('layout-2')} // Update the animation value when clicked
                                title="Layout-2"
                            >
                            <div className='vayu-blocks-main_parent_div'>
                                <article class="vayu-blocks-timeline__field-componets-new-way">
                                    <div class="vayu_blocks-timeline__events-inner-new-components-new_way">
                                    </div>
                                    <div class="vayu_blocks-timeline__marker-compoents vayu_blocks-timeline__in-view-icon-compoents"></div>
                                    <div class="vayu_blocks__date-new-compoents"><CiCalendarDate /></div>
                                    {/* <FaCaretLeft className='vayu_blcoks_left_icon_icon_timeline-layout4-left'/> */}
                                </article>
                                <article class="vayu-blocks-timeline__field-componets-new-way">
                                    <div class="vayu_blocks-timeline__events-inner-new-components-new_way">
                                    </div>
                                    <div class="vayu_blocks-timeline__marker-compoents vayu_blocks-timeline__in-view-icon-compoents"></div>
                                    <div class="vayu_blocks__date-new-compoents"><CiCalendarDate /></div>
                                    {/* <FaCaretLeft className='vayu_blcoks_left_icon_icon_timeline-layout4-left'/> */}
                                </article>
                                <article class="vayu-blocks-timeline__field-componets-new-way">
                                    <div class="vayu_blocks-timeline__events-inner-new-components-new_way">
                                    </div>
                                    <div class="vayu_blocks-timeline__marker-compoents vayu_blocks-timeline__in-view-icon-compoents"></div>
                                    <div class="vayu_blocks__date-new-compoents"><CiCalendarDate /></div>
                                    {/* <FaCaretLeft className='vayu_blcoks_left_icon_icon_timeline-layout4-left'/> */}
                                </article>

                                <hr className='vayu_blcoks_layout_hr_tag'/>
                            </div>
                                
                            </div>
                    </>
                    )}

                    {currentValue === 'top' && (
                        <>
                            {/* layout-7 */}
                            <div
                                className={`vayu_blocks-layout-main-div-timeline vayu_blocks-layout-7-main-div-timeline ${imageselectedAnimation === 'layout-7' ? 'selected' : ''}`}
                                onClick={() => handleimageAnimationClick('layout-7')} // Update the animation value when clicked
                                title="Layout-1"
                            >

                                <div class="vayu_blocks_timeline-child_block_main-componets-new-layout7">
                                    <hr className='vayu_blocks_hr_tag_hori'/>

                                    <article class="vayu-blocks-timeline__field-componets-new-layout7">
                                        <div class="vayu_blocks__date-new-compoents-new-layout7"><CiCalendarDate /></div>
                                        <div class="vayu_blocks-timeline__marker-compoents-new-layout7"></div>
                                        <div class="vayu_blocks-timeline__events-inner-new-components-new-layout7"></div>
                                        {/* <FaCaretUp className='vayu_blcoks_left_icon_icon_timeline-layout7-main'/> */}
                                    </article>

                                    <article class="vayu-blocks-timeline__field-componets-new-layout7">
                                        <div class="vayu_blocks__date-new-compoents-new-layout7"><CiCalendarDate /></div>
                                        <div class="vayu_blocks-timeline__marker-compoents-new-layout7"></div>
                                        <div class="vayu_blocks-timeline__events-inner-new-components-new-layout7"></div>
                                        {/* <FaCaretUp className='vayu_blcoks_left_icon_icon_timeline-layout7-more'/> */}
                                    </article>

                                    <article class="vayu-blocks-timeline__field-componets-new-layout7">
                                        <div class="vayu_blocks__date-new-compoents-new-layout7"><CiCalendarDate /></div>
                                        <div class="vayu_blocks-timeline__marker-compoents-new-layout7"></div>
                                        <div class="vayu_blocks-timeline__events-inner-new-components-new-layout7"></div>
                                        {/* <FaCaretUp className='vayu_blcoks_left_icon_icon_timeline-layout7-moremuch'/> */}
                                    </article>
                                
                                </div>
                                
                            </div>
                        </>
                    )}

                    {currentValue === 'bottom' && (
                        <>

                            {/* layout-8 */}
                            <div
                                className={`vayu_blocks-layout-main-div-timeline vayu_blocks-layout-8-main-div-timeline ${imageselectedAnimation === 'layout-8' ? 'selected' : ''}`}
                                onClick={() => handleimageAnimationClick('layout-8')} // Update the animation value when clicked
                                title="Layout-2"
                            >
                                <div class="vayu_blocks_timeline-child_block_main-componets-new-layout">
                                    <hr className='vayu_blocks_hr_tag_hori-lay'/>

                                    <article class="vayu-blocks-timeline__field-componets-new-layout">
                                        <div class="vayu_blocks-timeline__events-inner-new-components-new-layout"></div>
                                        <div class="vayu_blocks-timeline__marker-compoents-new-layout"></div>
                                        <div class="vayu_blocks__date-new-compoents-new-layout"><CiCalendarDate /></div>
                                        {/* <FaCaretDown className='vayu_blcoks_left_icon_icon_timeline-layout8'/> */}
                                    </article>

                                    <article class="vayu-blocks-timeline__field-componets-new-layout">
                                        <div class="vayu_blocks-timeline__events-inner-new-components-new-layout"></div>
                                        <div class="vayu_blocks-timeline__marker-compoents-new-layout"></div>
                                        <div class="vayu_blocks__date-new-compoents-new-layout"><CiCalendarDate /></div>
                                        {/* <FaCaretDown className='vayu_blcoks_left_icon_icon_timeline-layout8-much'/> */}
                                    </article>

                                    <article class="vayu-blocks-timeline__field-componets-new-layout">
                                        <div class="vayu_blocks-timeline__events-inner-new-components-new-layout"></div>
                                        <div class="vayu_blocks-timeline__marker-compoents-new-layout"></div>
                                        <div class="vayu_blocks__date-new-compoents-new-layout"><CiCalendarDate /></div>
                                        {/* <FaCaretDown className='vayu_blcoks_left_icon_icon_timeline-layout8-muchmore'/> */}
                                    </article>
                                </div>
                                
                            </div> 
                        
                        </>
                    )}

                    {currentValue === 'left' && (
                        <>
                            {/* layout-4 */}
                            <div
                                className={`vayu_blocks-layout-main-div-timeline vayu_blocks-layout-2-main-div-timeline ${imageselectedAnimation === 'layout-4' ? 'selected' : ''}`}
                                onClick={() => handleimageAnimationClick('layout-4')} // Update the animation value when clicked
                                title="Layout-4"
                            >
                            
                            <div className='vayu-blocks-main_parent_div'>
                                <article class="vayu-blocks-timeline__field-componets-new-way vayu-blocks-main_rotate_div_not vayu_blocks_layout_4_div_not">
                                    <div class="vayu_blocks-timeline__events-inner-new-components-new_way">
                                    </div>
                                    <div class="vayu_blocks-timeline__marker-compoents vayu_blocks-timeline__in-view-icon-compoents"></div>
                                    <div class="vayu_blocks__date-new-compoents"><CiCalendarDate /></div>
                                    {/* <FaCaretRight className='vayu_blcoks_left_icon_icon_timeline-layout4'/> */}
                                </article>
                                <article class="vayu-blocks-timeline__field-componets-new-way">
                                    <div class="vayu_blocks-timeline__events-inner-new-components-new_way">
                                    </div>
                                    <div class="vayu_blocks-timeline__marker-compoents vayu_blocks-timeline__in-view-icon-compoents"></div>
                                    <div class="vayu_blocks__date-new-compoents"><CiCalendarDate /></div>
                                    {/* <FaCaretLeft className='vayu_blcoks_left_icon_icon_timeline-layout4-left'/> */}
                                </article>
                                <article class="vayu-blocks-timeline__field-componets-new-way vayu-blocks-main_rotate_div_not vayu_blocks_layout_4_div_not">
                                    <div class="vayu_blocks-timeline__events-inner-new-components-new_way">
                                    </div>
                                    <div class="vayu_blocks-timeline__marker-compoents vayu_blocks-timeline__in-view-icon-compoents"></div>
                                    <div class="vayu_blocks__date-new-compoents"><CiCalendarDate /></div>
                                    {/* <FaCaretRight className='vayu_blcoks_left_icon_icon_timeline-layout4'/> */}
                                </article>

                                <hr className='vayu_blcoks_layout_hr_tag'/>
                            </div>
                                
                            </div>
                        </>
                    )}

                    {currentValue === 'right' && (
                        <>
                        
                            {/* layout-3 */}
                            <div
                                className={`vayu_blocks-layout-main-div-timeline vayu_blocks-layout-1-main-div-timeline ${imageselectedAnimation === 'layout-3' ? 'selected' : ''}`}
                                onClick={() => handleimageAnimationClick('layout-3')} // Update the animation value when clicked
                                title="Layout-3"
                            >
                                <div className='vayu-blocks-main_parent_div'>
                                    <article class="vayu-blocks-timeline__field-componets-new-way vayu-blocks-main_rotate_div">
                                        <div class="vayu_blocks-timeline__events-inner-new-components-new_way">
                                        </div>
                                        <div class="vayu_blocks-timeline__marker-compoents vayu_blocks-timeline__in-view-icon-compoents"></div>
                                        <div class="vayu_blocks__date-new-compoents"><CiCalendarDate /></div>
                                        {/* <FaCaretLeft className='vayu_blcoks_left_icon_icon_timeline-layout4-left'/> */}
                                    </article>
                                    <article class="vayu-blocks-timeline__field-componets-new-way">
                                        <div class="vayu_blocks-timeline__events-inner-new-components-new_way">
                                        </div>
                                        <div class="vayu_blocks-timeline__marker-compoents vayu_blocks-timeline__in-view-icon-compoents"></div>
                                        <div class="vayu_blocks__date-new-compoents"><CiCalendarDate /></div>
                                        {/* <FaCaretRight className='vayu_blcoks_left_icon_icon_timeline-layout4'/> */}
                                    </article>
                                    <article class="vayu-blocks-timeline__field-componets-new-way vayu-blocks-main_rotate_div">
                                        <div class="vayu_blocks-timeline__events-inner-new-components-new_way">
                                        </div>
                                        <div class="vayu_blocks-timeline__marker-compoents vayu_blocks-timeline__in-view-icon-compoents"></div>
                                        <div class="vayu_blocks__date-new-compoents"><CiCalendarDate /></div>
                                        {/* <FaCaretLeft className='vayu_blcoks_left_icon_icon_timeline-layout4-left'/> */}
                                    </article>

                                    <hr className='vayu_blcoks_layout_hr_tag'/>
                                </div>
                                
                                
                            </div>
                        </>
                    )}

                    {/* layout-9 */}
                    {/* {currentValue === 'top' && (
                        <>
                        
                            
                            <div
                                className={`vayu_blocks-layout-main-div-timeline vayu_blocks-layout-9-main-div-timeline ${imageselectedAnimation === 'layout-9' ? 'selected' : ''}`}
                                onClick={() => handleimageAnimationClick('layout-9')} // Update the animation value when clicked
                                title="Layout-3"
                            >
                            <div class="vayu_blocks_timeline-child_block_main-componets-new-layout7">
                                    <hr className='vayu_blocks_hr_tag_hori-lay7'/>

                                    <article class="vayu-blocks-timeline__field-componets-new-layout">
                                        <div class="vayu_blocks-timeline__events-inner-new-components-new-layout"></div>
                                        <div class="vayu_blocks-timeline__marker-compoents-new-layout"></div>
                                        <div class="vayu_blocks__date-new-compoents-new-layout"><CiCalendarDate /></div>
                                        <FaCaretDown className='vayu_blcoks_left_icon_icon_timeline-layout9'/>
                                    </article>

                                    <article class="vayu-blocks-timeline__field-componets-new-layout7">
                                        <div class="vayu_blocks__date-new-compoents-new-layout7"><CiCalendarDate /></div>
                                        <div class="vayu_blocks-timeline__marker-compoents-new-layout7"></div>
                                        <div class="vayu_blocks-timeline__events-inner-new-components-new-layout7"></div>
                                        <FaCaretUp className='vayu_blcoks_left_icon_icon_timeline-layout9-much'/>
                                    </article>

                                    <article class="vayu-blocks-timeline__field-componets-new-layout">
                                        <div class="vayu_blocks-timeline__events-inner-new-components-new-layout"></div>
                                        <div class="vayu_blocks-timeline__marker-compoents-new-layout"></div>
                                        <div class="vayu_blocks__date-new-compoents-new-layout"><CiCalendarDate /></div>
                                        <FaCaretDown className='vayu_blcoks_left_icon_icon_timeline-layout9-muchmore'/>
                                    </article>
                                </div>
                                
                            </div>

                        </>
                    )} */}
                    {/* layout-10 */}
                    {/* {currentValue === 'bottom' && (
                        <>
                            
                            <div
                                className={`vayu_blocks-layout-main-div-timeline vayu_blocks-layout-10-main-div-timeline ${imageselectedAnimation === 'layout-10' ? 'selected' : ''}`}
                                onClick={() => handleimageAnimationClick('layout-10')} // Update the animation value when clicked
                                title="Layout-4"
                            >
                            
                                <div class="vayu_blocks_timeline-child_block_main-componets-new-layout">
                                    <hr className='vayu_blocks_hr_tag_hori-lay7'/>
                                    <article class="vayu-blocks-timeline__field-componets-new-layout7">
                                            <div class="vayu_blocks__date-new-compoents-new-layout7"><CiCalendarDate /></div>
                                            <div class="vayu_blocks-timeline__marker-compoents-new-layout7"></div>
                                            <div class="vayu_blocks-timeline__events-inner-new-components-new-layout7"></div>
                                            <FaCaretUp className='vayu_blcoks_left_icon_icon_timeline-layout10'/>
                                        </article>

                                        <article class="vayu-blocks-timeline__field-componets-new-layout">
                                            <div class="vayu_blocks-timeline__events-inner-new-components-new-layout"></div>
                                            <div class="vayu_blocks-timeline__marker-compoents-new-layout"></div>
                                            <div class="vayu_blocks__date-new-compoents-new-layout"><CiCalendarDate /></div>
                                            <FaCaretDown className='vayu_blcoks_left_icon_icon_timeline-layout10-much'/>
                                        </article>

                                        <article class="vayu-blocks-timeline__field-componets-new-layout7">
                                            <div class="vayu_blocks__date-new-compoents-new-layout7"><CiCalendarDate /></div>
                                            <div class="vayu_blocks-timeline__marker-compoents-new-layout7"></div>
                                            <div class="vayu_blocks-timeline__events-inner-new-components-new-layout7"></div>
                                            <FaCaretUp className='vayu_blcoks_left_icon_icon_timeline-layout10-muchmore'/>
                                        </article>
                                </div>
                                
                            </div>
                        </>
                    )} */}

                    {currentValue === 'left' && (
                        <>
                            {/* layout-6 */}
                            <div
                                className={`vayu_blocks-layout-main-div-timeline vayu_blocks-layout-6-main-div-timeline ${imageselectedAnimation === 'layout-6' ? 'selected' : ''}`}
                                onClick={() => handleimageAnimationClick('layout-6')} // Update the animation value when clicked
                                title="Layout-6"
                            >
                            
                            <div className='vayu-blocks-main_parent_div'>
                                <article class="vayu-blocks-timeline__field-componets-new-way">
                                    <div class="vayu_blocks-timeline__events-inner-new-components-new_way vayu_blcoks_layout_6">
                                    </div>
                                    <div class="vayu_blocks-timeline__marker-compoents vayu_blocks-timeline__in-view-icon-compoents"></div>
                                    {/* <FaCaretRight className='vayu_blcoks_left_icon_icon_timeline-layout6'/> */}
                                </article>
                                <article class="vayu-blocks-timeline__field-componets-new-way">
                                    <div class="vayu_blocks-timeline__events-inner-new-components-new_way vayu_blcoks_layout_6">
                                    </div>
                                    <div class="vayu_blocks-timeline__marker-compoents vayu_blocks-timeline__in-view-icon-compoents"></div>
                                    {/* <FaCaretRight className='vayu_blcoks_left_icon_icon_timeline-layout6'/> */}
                                </article>
                                <article class="vayu-blocks-timeline__field-componets-new-way">
                                    <div class="vayu_blocks-timeline__events-inner-new-components-new_way vayu_blcoks_layout_6">
                                    </div>
                                    <div class="vayu_blocks-timeline__marker-compoents vayu_blocks-timeline__in-view-icon-compoents"></div>
                                    {/* <FaCaretRight className='vayu_blcoks_left_icon_icon_timeline-layout6'/> */}
                                </article>

                                <hr className='vayu_blcoks_layout_hr_tag-vayu_blcoks_layout_6 '/>
                            </div>
                                
                            </div>
                        </>
                    )}

                    {currentValue === 'right' && (
                        <>
                            {/* layout-5 */}
                            <div
                                className={`vayu_blocks-layout-main-div-timeline vayu_blocks-layout-5-main-div-timeline ${imageselectedAnimation === 'layout-5' ? 'selected' : ''}`}
                                onClick={() => handleimageAnimationClick('layout-5')} // Update the animation value when clicked
                                title="Layout-5"
                            >
                            
                            <div className='vayu-blocks-main_parent_div vayu_blcoks_reversE_direction_remove'>
                                <article class="vayu-blocks-timeline__field-componets-new-way">
                                    <div class="vayu_blocks-timeline__events-inner-new-components-new_way vayu_blcoks_layout_6">
                                    </div>
                                    <div class="vayu_blocks-timeline__marker-compoents vayu_blocks-timeline__in-view-icon-compoents"></div>
                                    {/* <FaCaretLeft className='vayu_blcoks_left_icon_icon_timeline-layout5-left'/> */}
                                </article>
                                <article class="vayu-blocks-timeline__field-componets-new-way">
                                    <div class="vayu_blocks-timeline__events-inner-new-components-new_way vayu_blcoks_layout_6">
                                    </div>
                                    <div class="vayu_blocks-timeline__marker-compoents vayu_blocks-timeline__in-view-icon-compoents"></div>
                                    {/* <FaCaretLeft className='vayu_blcoks_left_icon_icon_timeline-layout5-left'/> */}
                                </article>
                                <article class="vayu-blocks-timeline__field-componets-new-way">
                                    <div class="vayu_blocks-timeline__events-inner-new-components-new_way vayu_blcoks_layout_6">
                                    </div>
                                    <div class="vayu_blocks-timeline__marker-compoents vayu_blocks-timeline__in-view-icon-compoents"></div>
                                    {/* <FaCaretLeft className='vayu_blcoks_left_icon_icon_timeline-layout5-left'/> */}
                                </article>

                                <hr className='vayu_blcoks_layout_hr_tag-vayu_blcoks_layout_5 '/>
                            </div>
                                
                            </div>
                        
                        </>
                    )}

                    {currentValue === 'top' && (
                        <>
                            {/* layout-11 */}
                            <div
                                className={`vayu_blocks-layout-main-div-timeline vayu_blocks-layout-11-main-div-timeline ${imageselectedAnimation === 'layout-11' ? 'selected' : ''}`}
                                onClick={() => handleimageAnimationClick('layout-11')} // Update the animation value when clicked
                                title="Layout-5"
                            >
                            
                            <div class="vayu_blocks_timeline-child_block_main-componets-new-layout7">
                                    <hr className='vayu_blocks_hr_tag_hori-lay11'/>

                                    <article class="vayu-blocks-timeline__field-componets-new-layout7 ">
                                        <div class="vayu_blocks-timeline__marker-compoents-new-layout7"></div>
                                        <div class="vayu_blocks-timeline__events-inner-new-components-new-layout7"></div>
                                        {/* <FaCaretUp className='vayu_blcoks_left_icon_icon_timeline-layout7'/> */}
                                    </article>

                                    <article class="vayu-blocks-timeline__field-componets-new-layout7">
                                        <div class="vayu_blocks-timeline__marker-compoents-new-layout7"></div>
                                        <div class="vayu_blocks-timeline__events-inner-new-components-new-layout7"></div>
                                        {/* <FaCaretUp className='vayu_blcoks_left_icon_icon_timeline-layout7-much'/> */}
                                    </article>

                                    <article class="vayu-blocks-timeline__field-componets-new-layout7">
                                        <div class="vayu_blocks-timeline__marker-compoents-new-layout7"></div>
                                        <div class="vayu_blocks-timeline__events-inner-new-components-new-layout7"></div>
                                        {/* <FaCaretUp className='vayu_blcoks_left_icon_icon_timeline-layout7-muchmore'/> */}
                                    </article>
                                </div>
                                
                            </div>
                        </>
                    )}

                    {currentValue === 'bottom' && (
                        <>
                            {/* layout-12 */}
                            <div
                                className={`vayu_blocks-layout-main-div-timeline vayu_blocks-layout-12-main-div-timeline ${imageselectedAnimation === 'layout-12' ? 'selected' : ''}`}
                                onClick={() => handleimageAnimationClick('layout-12')} // Update the animation value when clicked
                                title="Layout-6"
                            >
                            
                            <div class="vayu_blocks_timeline-child_block_main-componets-new-layout">
                                    <hr className='vayu_blocks_hr_tag_hori-lay12'/>

                                    <article class="vayu-blocks-timeline__field-componets-new-layout">
                                        <div class="vayu_blocks-timeline__events-inner-new-components-new-layout"></div>
                                        <div class="vayu_blocks-timeline__marker-compoents-new-layout"></div>
                                        {/* <FaCaretDown className='vayu_blcoks_left_icon_icon_timeline-layout12'/> */}
                                    </article>

                                    <article class="vayu-blocks-timeline__field-componets-new-layout">
                                        <div class="vayu_blocks-timeline__events-inner-new-components-new-layout"></div>
                                        <div class="vayu_blocks-timeline__marker-compoents-new-layout"></div>
                                        {/* <FaCaretDown className='vayu_blcoks_left_icon_icon_timeline-layout12-much'/> */}
                                    </article>

                                    <article class="vayu-blocks-timeline__field-componets-new-layout">
                                        <div class="vayu_blocks-timeline__events-inner-new-components-new-layout"></div>
                                        <div class="vayu_blocks-timeline__marker-compoents-new-layout"></div>
                                        {/* <FaCaretDown className='vayu_blcoks_left_icon_icon_timeline-layout12-muchmore'/> */}
                                    </article>
                                </div>
                            </div>
                        </>
                    )}

                </div>
            </div>

            </div>
                
        </div>
    );
};

